export type ComparisonRow = {
  without: string
  with: string
}

export const comparisonRows: ComparisonRow[] = [
  {
    without: '+100 horas al año planificando desde cero',
    with: '5 minutos por semana. Todo listo.',
  },
  {
    without: 'Los mismos 10 ejercicios repetidos sin progresión',
    with: '+150 ejercicios organizados por nivel',
  },
  {
    without: 'Alumnos que mejoran lento y pierden la motivación',
    with: 'Progresión de nivel clara y medible',
  },
  {
    without: 'Clases canceladas cuando llueve',
    with: '10 sesiones bajo techo siempre listas',
  },
  {
    without: 'Llegar a la cancha sin preparación',
    with: 'Entrar a la cancha con confianza, siempre',
  },
  {
    without: 'Sin un sistema visible: los padres dudan de tu método',
    with: 'Un entrenador estructurado, creíble y profesional',
  },
]

export const problems: string[] = [
  'Pasar horas cada semana planificando sesiones desde cero',
  'Quedarte sin ejercicios y repetir siempre los mismos',
  'No saber cómo estructurar la progresión de una temporada completa',
  'Batallar con grupos de niveles mezclados',
  'No tener un sistema para medir y mostrar el progreso de tus alumnos',
  'Llegar a la cancha sin un plan claro',
  'Perder ingresos cada vez que un alumno cancela a último momento',
  'Sentir que deberías hacer más, pero no saber cómo',
]

export const packageIncludes: string[] = [
  '12 Volúmenes Completos — todos los niveles cubiertos',
  '6 Bonos Estratégicos — incluidos gratis',
  '+150 Ejercicios Profesionales con diagramas',
  '+280 Páginas de contenido listo para usar',
  'Acceso de por Vida — tuyo para siempre',
  'PDFs optimizados para móvil e impresión A4',
]
